import { isEmpty } from 'Util/isEmpty';

import { IndustryTypes } from './IndustryTypes';
import { MoneyValue } from './MoneyValue';
import { Nullable } from './Nullable';
import { PriceFieldCategories } from './PriceFieldCategories';
import { SearchableEnumPresent } from './PropertyMap';
import { TextValue } from './TextValue';

export type PriceField = {
    type: null
    id: string
    org: {
        id: string
    }
    name: Nullable<TextValue>
    price: MoneyValue
    materialPrice: Nullable<MoneyValue>
    expectedTime: Nullable<{ minutes: number }>
    categories: SearchableEnumPresent<PriceFieldCategories.Types>
    subCategories: SearchableEnumPresent<PriceFieldCategories.Types>
    industryTypes: SearchableEnumPresent<IndustryTypes.IndustryTypes>
    template: Nullable<{
        id: string
    }>
}

export function noPriceFieldNameText(name?: string) {
    return isEmpty(name) ? 'Navnløst prisfelt' : name
}